import {
  GET_HR_LOAN_MASTER,
  CREATE_HR_LOAN_MASTER,
  UPDATE_HR_LOAN_MASTER,
  DELETE_HR_LOAN_MASTER,
  GET_HR_LOAN_TYPE_MASTER,
  CREATE_HR_LOAN_TYPE_MASTER,
  UPDATE_HR_LOAN_TYPE_MASTER,
  DELETE_HR_LOAN_TYPE_MASTER,
  GET_HR_COLLATERAL_TYPE_MASTER,
  CREATE_HR_COLLATERAL_TYPE_MASTER,
  UPDATE_HR_COLLATERAL_TYPE_MASTER,
  DELETE_HR_COLLATERAL_TYPE_MASTER,
} from "../actions/types";

const initialState = {
  hrLoanMasterList: [],
  hrLoanTypeMasterList: [],
  hrCollateralTypeMasterList: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_HR_LOAN_MASTER:
      return { ...state, hrLoanMasterList: action.payload };
    case CREATE_HR_LOAN_MASTER:
    case UPDATE_HR_LOAN_MASTER:
    case DELETE_HR_LOAN_MASTER:
      return { ...state };

    case GET_HR_LOAN_TYPE_MASTER:
      return { ...state, hrLoanTypeMasterList: action.payload };
    case CREATE_HR_LOAN_TYPE_MASTER:
    case UPDATE_HR_LOAN_TYPE_MASTER:
    case DELETE_HR_LOAN_TYPE_MASTER:
      return { ...state };

    case GET_HR_COLLATERAL_TYPE_MASTER:
      return { ...state, hrCollateralTypeMasterList: action.payload };
    case CREATE_HR_COLLATERAL_TYPE_MASTER:
    case UPDATE_HR_COLLATERAL_TYPE_MASTER:
    case DELETE_HR_COLLATERAL_TYPE_MASTER:
      return { ...state };

    default:
      return state;
  }
}